import Service from "@/services/param";
//import {router} from '@/plugins/router'

export default {
  namespaced: false,
  state: {
    param: {},
  },
  actions: {
    getParam({ dispatch, commit }) {
      Service.get()
        .then((data) => {
          commit("param", data.data);
        })
        .catch((err) => {
          //dispatch("alert/error", err, { root: true });
        });
    },
  },
  mutations: {
    param(state, param) {
      state.param = param;
    },
  },
};
